import type { SyntheticEvent } from 'react';

export function stopPropagation<Event extends Pick<SyntheticEvent, 'stopPropagation'>>(event: Event): Event {
  event.stopPropagation();

  return event;
}
